import { jsx as o } from "react/jsx-runtime";
import { useChatbotContext as a } from "../../hooks/useChatbotContext.js";
function c() {
  const { embedConfig: e } = a();
  if (!e || !e.logoImageUrl)
    return null;
  const { logoImageUrl: r, logoLinkUrl: t, logoHeight: n = 34 } = e;
  return /* @__PURE__ */ o("div", { className: "grid grow place-items-center px-2 py-2", children: t ? /* @__PURE__ */ o("a", { href: t, target: "_blank", rel: "noopener noreferrer", children: /* @__PURE__ */ o(l, { logoImageUrl: r, logoHeight: n }) }) : /* @__PURE__ */ o(l, { logoImageUrl: r, logoHeight: n }) });
}
function l({
  logoImageUrl: e,
  logoHeight: r
}) {
  return /* @__PURE__ */ o("span", { className: "block w-auto max-w-[350px]", style: { height: r }, children: /* @__PURE__ */ o(
    "img",
    {
      src: e,
      alt: "Logo",
      className: "h-full w-auto object-contain"
    }
  ) });
}
export {
  c as EmbedLogo
};
